import React, { useState } from "react";
import { Link } from "react-router-dom";
import { MdHome, MdPerson, MdWork, MdArrowDropDown } from "react-icons/md"; // Importing icons
import Log from "../Assets/Landing/Navbar/Log.png";

const Navbar = () => {
  const [dropdown, setDropdown] = useState(false);
  const [authDropdown, setAuthDropdown] = useState(false);

  const handleDropdownEnter = () => {
    setDropdown(true);
  };

  const handleDropdownLeave = () => {
    setDropdown(false);
  };

  const handleAuthDropdownEnter = () => {
    setAuthDropdown(true);
  };

  const handleAuthDropdownLeave = () => {
    setAuthDropdown(false);
  };

  return (
    <>
      <nav className="mb-2">
        <div className="  p-3 flex items-center justify-between bg-background py-6">
          {/* Logo on the Left Side */}
          <div className="flex items-center gap-2">
            <Link to="/">
              <span className="text-textWhite font-normal text-3xl">JobGenee</span>
            </Link>
          </div>

          {/* Center Links */}
          <div className="hidden md:block">
            <ul className="flex items-center gap-6 text-textWhite ">
              <li>
                <Link
                  to="/"
                  className="inline-block py-1 px-3 text-3xl font-normal hover:text-primary"
                >
                  Home
                </Link>
              </li>
              <li>
                <Link
                  to="/#"
                  className="inline-block py-1 px-3 text-3xl font-normal hover:text-primary"
                >
                  Services
                </Link>
              </li>
            </ul>
          </div>

          {/* Action Buttons */}
          <div className="gap-5 hidden md:flex">
            {/* Sign In/Up Dropdown */}
            <div
              className="relative"
              onMouseEnter={handleAuthDropdownEnter}
              onMouseLeave={handleAuthDropdownLeave}
            >
              <button className="hover:bg-background2 text-textWhite font-semibold hover:text-white bg-logos px-6 py-2 duration-200 rounded-md flex items-center gap-2">
                Sign In/Up <MdArrowDropDown />
              </button>
              {authDropdown && (
                <div className="absolute top-full left-0 mt-0.5 w-40 bg-white border-2 border-[#0077af] rounded-md shadow-lg">
                  <ul className="flex flex-col text-gray-600 font-bold">
                    <li>
                      <Link
                        to="/HomeLogin"
                        className="block py-2 px-4 hover:bg-[#0077af] hover:text-white"
                      >
                        Login
                      </Link>
                    </li>
                    <div className="h-px bg-gradient-to-r from-transparent via-gray-300 to-transparent blur-sm"></div>
                    <li>
                      <Link
                        to="/HomeRegister"
                        className="block py-2 px-4 hover:bg-[#0077af] hover:text-white"
                      >
                        Registration
                      </Link>
                    </li>
                  </ul>
                </div>
              )}
            </div>

            {/* Employers Button with Hover Dropdown */}
            <div
              className="relative"
              onMouseEnter={handleDropdownEnter}
              onMouseLeave={handleDropdownLeave}
            >
              <button className="text-textWhite font-semibold flex items-center gap-2 hover:bg-[#0077af] hover:text-white border-4 border-logos px-6 py-2 duration-200 rounded-md">
                Employers <MdArrowDropDown />
              </button>
              {dropdown && (
                <div className="absolute top-full left-0 mt-0.5 w-40 bg-white border-2 border-[#0077af] rounded-md shadow-lg">
                  <ul className="flex flex-col text-gray-600 font-bold">
                    <li>
                      <Link
                        to="/EmployerEnquiry"
                        className="block py-2 px-4 hover:bg-[#0077af] hover:text-white"
                      >
                        Enquiry
                      </Link>
                    </li>
                    <div className="h-px bg-gradient-to-r from-transparent via-gray-300 to-transparent blur-sm"></div>
                    <li>
                      <Link
                        to="/EmployerLogin"
                        className="block py-2 px-4 hover:bg-[#0077af] hover:text-white"
                      >
                        Login
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/EmployerRegistrationForm"
                        className="block py-2 px-4 hover:bg-[#0077af] hover:text-white"
                      >
                        Registration
                      </Link>
                    </li>
                    <div className="h-px bg-gradient-to-r from-transparent via-gray-300 to-transparent blur-sm"></div>
                    <li>
                      <Link
                        to="/buyplan"
                        className="block py-2 px-4 hover:bg-[#0077af] hover:text-white"
                      >
                        Buy Plan
                      </Link>
                    </li>
                  </ul>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Responsive Menu - Fixed at Bottom */}
        <div className="md:hidden fixed inset-x-0 bottom-0 bg-white border-t border-gray-300 z-50">
          <div className="flex justify-around items-center py-3 text-gray-500">
            <Link
              to="/"
              className="flex flex-col items-center gap-1 text-lg font-bold hover:text-[#0077af]"
            >
              <MdHome className="text-3xl" />
              <span>Home</span>
            </Link>
            <Link
              to="/#"
              className="flex flex-col items-center gap-1 text-lg font-bold hover:text-[#0077af]"
            >
              <MdWork className="text-3xl" />
              <span>Services</span>
            </Link>
          </div>
        </div>
      </nav>
    </>
  );
};

export default Navbar;